export const baseStyles = {
  allergiesList: {
    base: 'mx-auto w-full max-w-3xl px-4 pb-10',
    list: 'grid grid-cols-2 gap-2 text-sm md:grid-cols-4',
    item: 'flex items-center gap-2',
    heading: 'mb-4 text-2xl font-bold flex items-center gap-2',
    filterLink: 'ml-2 cursor-pointer text-sm font-normal underline text-secondary ml-auto',
    groupHeading: 'mt-6 mb-3 flex items-center gap-2 text-lg font-bold',
  },
  languageButton: {
    base: 'block w-full',
  },
  menuCategory: {
    base: 'grid gap-4',
    title: 'text-xl font-bold',
    description: 'text-sm text-gray-500',
  },
  menuIcon: {
    base: '',
  },
  iconTooltip: {
    wrapper: 'relative inline-flex',
    trigger: 'inline-flex cursor-default items-center justify-center',
    badge: 'pointer-events-none absolute -top-1.5 -right-1.5 flex h-3.5 min-w-3.5 items-center justify-center rounded-full px-0.5 text-[9px] leading-none font-bold text-white',
    tooltip: 'pointer-events-none absolute bottom-full left-1/2 z-50 mb-1.5 w-max max-w-[240px] -translate-x-1/2 rounded bg-black px-2 py-1 text-center text-xs text-white shadow-lg',
  },
  menuItem: {
    base: '',
    labelBase: '',
    titleWrapper: '',
    title: '',
    description: '',
    priceList: '',
    priceItem: '',
    icons: 'flex gap-2',
    label: '',
  },
  menuSubCategory: {
    base: '',
    title: '',
    description: '',
  },
  menuTextBlock: {
    base: '',
    title: '',
    description: '',
  },
  menuTitleBlock: {
    base: '',
    title: '',
  },
  page: {
    section: 'flex min-h-screen items-center justify-center p-4',
    container:
      'mx-auto flex w-full max-w-86 flex-col items-center justify-between gap-6 text-center',
    heading: '',
    menuSection: 'mx-auto w-full max-w-3xl px-4 py-16',
    menuNotice: 'mb-8',
    menuHeading: '',
    menuDescription: '',
    menuGrid: 'grid w-full gap-10',
    filterNoResults: 'py-12 text-center text-lg opacity-50',
  },
  filterBar: {
    bar: 'flex w-full cursor-pointer items-center gap-3 bg-white px-4 py-3 text-sm border-b border-black/10 text-black',
    barContainer: 'container mx-auto flex max-w-3xl items-center gap-3 md:px-4',
    barTitle: 'font-semibold',
    backdrop: 'fixed inset-0 z-40 bg-black/40',
    popover: 'fixed inset-0 z-50 flex flex-col bg-white md:inset-auto md:left-1/2 md:top-1/2 md:h-[80vh] md:w-full md:max-w-sm md:-translate-x-1/2 md:-translate-y-1/2 md:rounded-lg md:shadow-xl',
    popoverHeader: 'flex items-center justify-between border-b border-black/10 px-4 py-3 md:rounded-t-lg',
    popoverTitle: 'text-sm font-semibold',
    closeButton: 'flex h-8 w-8 items-center justify-center rounded-full bg-black text-white text-xl leading-none font-bold cursor-pointer hover:bg-gray-600 transition-colors',
    closeButtonInner: 'w-4 h-4',
    list: 'flex-1 overflow-y-auto',
    stickyHeader: 'sticky top-0 z-20 bg-white',
    search: 'border-b border-black/10 bg-white p-3',
    searchInput: 'w-full rounded-md border border-black/15 bg-white px-3 py-2 text-sm text-black outline-none placeholder:text-gray-400 focus:border-black/40',
    tabList: 'flex border-b border-black/10 bg-white',
    tab: 'flex-1 cursor-pointer select-none border-b-2 border-transparent px-4 py-3 text-center text-sm font-medium text-gray-500 transition-colors hover:text-black',
    tabActive: 'border-black font-bold text-black',
    searchEmpty: 'px-4 py-8 text-center text-sm text-gray-500',
    allergenInfo: 'px-4 pb-3 text-xs text-gray-600',
    masterItem: 'flex cursor-pointer items-center gap-3 border-b border-black/10 px-4 py-3 font-semibold select-none hover:bg-black/5',
    listItem: 'flex cursor-pointer items-center gap-3 border-b border-black/10 px-4 py-3 transition-colors select-none hover:bg-black/5',
    subItem: 'flex cursor-pointer items-center gap-3 border-b border-black/10 py-3 pr-4 pl-11 transition-colors select-none hover:bg-black/5',
    checkbox: 'pointer-events-none h-4 w-4 shrink-0 rounded',
    itemLabel: 'text-sm',
    groupLabel: 'px-4 pt-4 pb-2 text-xs font-bold uppercase tracking-wide text-gray-500',
    groupSeparator: 'border-t border-black/10',
    popoverFooter: 'border-t border-black/10 p-4 md:rounded-b-lg flex flex-col gap-2',
    resetButton: 'w-full cursor-pointer rounded-lg border border-black/20 bg-transparent py-3 text-center text-sm font-semibold text-black transition-colors hover:bg-black/5',
    applyButton: 'w-full cursor-pointer rounded-lg bg-black py-3 text-center text-sm font-semibold text-white transition-colors hover:bg-gray-800',
  },
  themeLogo: {
    wrapper: '',
    image: 'bg-center bg-no-repeat object-contain object-center',
  },
}

export type BaseStyles = typeof baseStyles

export type ComponentName = keyof BaseStyles
